import { categories } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function FeatureGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <p className="text-foreground-500 text-xs tracking-widest uppercase mb-2">FEATURED CATEGORIES</p>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-100 mb-8">热门分类</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.filter((c) => c.key !== '全部').map((cat) => (
            <Link
              key={cat.key}
              to={`/category?cat=${cat.key}`}
              className="group flex flex-col items-center gap-3 p-5 bg-background-50 rounded-xl transition-colors hover:bg-background-200/70 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-full bg-primary-500/10 flex items-center justify-center group-hover:bg-primary-500/20 transition-colors">
                <i className={`${cat.icon} text-primary-500 text-xl`}></i>
              </div>
              <span className="text-foreground-200 text-sm font-medium">{cat.label}</span>
              <span className="text-foreground-600 text-xs">{cat.count} 部作品</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}